
// import React, { useState, useEffect, useMemo } from 'react';
// import axios from 'axios';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import * as XLSX from 'xlsx';
// import { jsPDF } from 'jspdf';
// import 'jspdf-autotable';
// import { useLocation } from 'react-router-dom';
// import { formatReadableAmount } from '../../../Common/FormatFunctions/FormatAmount';
// import { RingLoader } from 'react-spinners';
// import {
//   Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
//   Paper, Typography, TableFooter, Box, Grid
// } from '@mui/material';
// import { FormaDateBalanceSheet } from '../../../Common/FormatFunctions/FormatDate';

// const apikey = process.env.REACT_APP_API;

// // TODO: confirm the correct Tran_Type value expected by
// // generating_haladsaleBill_report_Govermentreversing for SALE transactions.
// // Passing the wrong value (or leaving it blank) will make the API return zero rows,
// // since the backend WHERE clause is a strict equality match with no fallback.
// const HALAD_TRAN_TYPE = 'GS' || 'OS'; // <-- CHANGE THIS to the real value used in your system

// const GST3BITCReport = () => {
//   const location = useLocation();
//   const Company_Name = sessionStorage.getItem('Company_Name');
//   const Company_GSTNO = sessionStorage.getItem('Company_GSTNO');
//   const searchParams = new URLSearchParams(location.search);

//   const [fromDate, setFromDate] = useState(searchParams.get('fromDate') || '');
//   const [toDate, setToDate] = useState(searchParams.get('toDate') || '');

//   const company_Code = sessionStorage.getItem("Company_Code");
//   const YearCode = sessionStorage.getItem("Year_Code");

//   const [saleData, setSaleData] = useState([]);
//   const [purchaseData, setPurchaseData] = useState([]);
//   const [haladSaleData, setHaladSaleData] = useState([]); // NEW
//   const [gulSaleData, setGulSaleData] = useState([]);     // NEW
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');

//   // NEW: controls which sale sources feed the ITC Calculation Summary (section 5).
//   // The register tables above always show full data regardless of these flags.
//   const [includeSale, setIncludeSale] = useState(true);
//   const [includeHalad, setIncludeHalad] = useState(true);
//   const [includeGul, setIncludeGul] = useState(true);

//   const SALE_API_URL = `${apikey}/generating_saleBill_report_Govermentreversing`;
//   const PURCHASE_API_URL = `${apikey}/generating_purchaseReport_report_govermentreversing`;
//   const HALAD_SALE_API_URL = `${apikey}/generating_haladsaleBill_report_Govermentreversing`; // NEW
//   const GUL_SALE_API_URL = `${apikey}/generating_gulsaleBill_report_Govermentreversing`;       // NEW

//   const formatDate = (dateString) => {
//     if (!dateString) return '';
//     const date = new Date(dateString);
//     const day = String(date.getDate()).padStart(2, '0');
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const year = String(date.getFullYear());
//     return `${day}/${month}/${year}`;
//   };

//   const fetchReportData = async () => {
//     if (!company_Code || !YearCode) return;
//     setLoading(true);
//     setError('');
//     try {
//       const commonParams = {
//         Company_Code: company_Code,
//         Year_Code: YearCode,
//         ...(fromDate && toDate ? { from_date: fromDate, to_date: toDate } : {}),
//       };

//       const [saleRes, purchaseRes, haladSaleRes, gulSaleRes] = await Promise.all([
//         axios.get(SALE_API_URL, { params: commonParams }),
//         axios.get(PURCHASE_API_URL, { params: commonParams }),
//         axios.get(HALAD_SALE_API_URL, { params: { ...commonParams, Tran_Type: HALAD_TRAN_TYPE } }), // NEW
//         axios.get(GUL_SALE_API_URL, { params: commonParams }), // NEW
//       ]);

//       setSaleData(saleRes.data?.all_data || []);
//       setPurchaseData(purchaseRes.data?.all_data || []);
//       setHaladSaleData(haladSaleRes.data?.all_data || []); // NEW
//       setGulSaleData(gulSaleRes.data?.all_data || []);       // NEW
//     } catch (err) {
//       console.error('Error fetching report:', err);
//       setError('Error fetching report');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchReportData();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [company_Code, YearCode]);

//   const handleApplyDates = () => {
//     fetchReportData();
//   };

//   // ---------- SALE REGISTER (grouped by saleid, one row per bill) ----------
//   const saleRows = useMemo(() => {
//     const grouped = {};
//     saleData.forEach((item) => {
//       const key = item.saleid;
//       if (!grouped[key]) grouped[key] = item;
//     });
//     return Object.values(grouped);
//   }, [saleData]);

//   const saleTotals = useMemo(() => {
//     return saleRows.reduce(
//       (acc, item) => {
//         const taxableAmt = Number(item.TaxableAmount) || 0;
//         const billAmt = Number(item.Bill_Amount) || 0;
//         const isNil = (Number(item.gstrate) || 0) === 0;
//         acc.billAmount += billAmt;
//         acc.cgst += Number(item.CGSTAmount) || 0;
//         acc.sgst += Number(item.SGSTAmount) || 0;
//         acc.igst += Number(item.IGSTAmount) || 0;
//         acc.netqntl += Number(item.NETQNTL) || 0;
//         if (isNil) {
//           acc.nilAmount += billAmt;
//         } else {
//           acc.taxable += taxableAmt;
//         }
//         return acc;
//       },
//       { taxable: 0, billAmount: 0, cgst: 0, sgst: 0, igst: 0, netqntl: 0, nilAmount: 0 }
//     );
//   }, [saleRows]);

//   // ---------- HALAD SALE REGISTER (grouped by doc_no, one row per bill) ---------- NEW
//   const haladSaleRows = useMemo(() => {
//     const grouped = {};
//     haladSaleData.forEach((item) => {
//       const key = item.doc_no;
//       if (!grouped[key]) grouped[key] = item;
//     });
//     return Object.values(grouped);
//   }, [haladSaleData]);

//   const haladSaleTotals = useMemo(() => {
//     // Halad (mandi/turmeric) sale bills carry no CGST/SGST/IGST/gstrate fields from the API,
//     // so the full bill amount is treated as nil-rated for the ITC nil% calculation.
//     return haladSaleRows.reduce(
//       (acc, item) => {
//         const billAmt = Number(item.Bill_Amount) || 0;
//         acc.subTotal += Number(item.SubTotal) || 0;
//         acc.billAmount += billAmt;
//         acc.nilAmount += billAmt;
//         return acc;
//       },
//       { subTotal: 0, billAmount: 0, nilAmount: 0 }
//     );
//   }, [haladSaleRows]);

//   // ---------- GUL SALE REGISTER (grouped by saleid, one row per bill) ---------- NEW
//   const gulSaleRows = useMemo(() => {
//     const grouped = {};
//     gulSaleData.forEach((item) => {
//       const key = item.saleid;
//       if (!grouped[key]) grouped[key] = item;
//     });
//     return Object.values(grouped);
//   }, [gulSaleData]);

//   const gulSaleTotals = useMemo(() => {
//     return gulSaleRows.reduce(
//       (acc, item) => {
//         const taxableAmt = Number(item.TaxableAmount) || 0;
//         const billAmt = Number(item.Bill_Amount) || 0;
//         const isNil = (Number(item.gstrate) || 0) === 0;
//         acc.billAmount += billAmt;
//         acc.cgst += Number(item.CGSTAmount) || 0;
//         acc.sgst += Number(item.SGSTAmount) || 0;
//         acc.igst += Number(item.IGSTAmount) || 0;
//         if (isNil) {
//           acc.nilAmount += billAmt;
//         } else {
//           acc.taxable += taxableAmt;
//         }
//         return acc;
//       },
//       { taxable: 0, billAmount: 0, cgst: 0, sgst: 0, igst: 0, nilAmount: 0 }
//     );
//   }, [gulSaleRows]);

//   // ---------- PURCHASE REGISTER (grouped by purchaseid, one row per bill) ----------
//   const purchaseRows = useMemo(() => {
//     const grouped = {};
//     purchaseData.forEach((item) => {
//       const key = item.purchaseid;
//       if (!grouped[key]) grouped[key] = item;
//     });
//     return Object.values(grouped);
//   }, [purchaseData]);

//   const purchaseTotals = useMemo(() => {
//     return purchaseRows.reduce(
//       (acc, item) => {
//         acc.taxable += Number(item.subTotal) || 0;
//         acc.billAmount += Number(item.Bill_Amount) || 0;
//         acc.cgst += Number(item.CGSTAmount) || 0;
//         acc.sgst += Number(item.SGSTAmount) || 0;
//         acc.igst += Number(item.IGSTAmount) || 0;
//         acc.netqntl += Number(item.NETQNTL) || 0;
//         return acc;
//       },
//       { taxable: 0, billAmount: 0, cgst: 0, sgst: 0, igst: 0, netqntl: 0 }
//     );
//   }, [purchaseRows]);

//   // ---------- FINAL CALCULATION / ITC REVERSAL SUMMARY ----------
//   // Which sources feed in is now controlled by includeSale / includeHalad / includeGul,
//   // so you can view Sale-only, Halad-only, Gul-only, or any combination.
//   // Halad never contributes taxable/GST amounts (it has none), only nil amount, when included.
//   const activeSourceLabel = useMemo(() => {
//     const parts = [];
//     if (includeSale) parts.push('Sale');
//     if (includeHalad) parts.push('Halad');
//     if (includeGul) parts.push('Gul');
//     return parts.length ? parts.join(' + ') : 'None selected';
//   }, [includeSale, includeHalad, includeGul]);

//   const summary = useMemo(() => {
//     const combinedTaxable =
//       (includeSale ? saleTotals.taxable : 0) + (includeGul ? gulSaleTotals.taxable : 0);

//     const combinedNil =
//       (includeSale ? saleTotals.nilAmount : 0) +
//       (includeHalad ? haladSaleTotals.nilAmount : 0) +
//       (includeGul ? gulSaleTotals.nilAmount : 0);

//     const totalSaleAmount = combinedTaxable + combinedNil;

//     const nilPercent = totalSaleAmount ? (combinedNil / totalSaleAmount) * 100 : 0;
//     const taxablePercent = totalSaleAmount ? 100 - nilPercent : 0;

//     const purchaseTotalGST = purchaseTotals.cgst + purchaseTotals.sgst + purchaseTotals.igst;
//     const itcReversalNil = purchaseTotalGST * (nilPercent / 100);
//     const eligibleITC = purchaseTotalGST - itcReversalNil;

//     // Total Sale GST across the currently selected sale sources (halad contributes 0 GST)
//     const totalSaleGST =
//       (includeSale ? saleTotals.cgst + saleTotals.sgst + saleTotals.igst : 0) +
//       (includeGul ? gulSaleTotals.cgst + gulSaleTotals.sgst + gulSaleTotals.igst : 0);

//     const payableAmount = eligibleITC - totalSaleGST;

//     return {
//       totalSaleAmount,
//       nilAmount: combinedNil,
//       taxableSaleAmount: combinedTaxable,
//       nilPercent,
//       taxablePercent,
//       purchaseTotalGST,
//       itcReversalNil,
//       eligibleITC,
//       totalSaleGST,
//       payableAmount,
//     };
//   }, [saleTotals, haladSaleTotals, gulSaleTotals, purchaseTotals, includeSale, includeHalad, includeGul]);

//   // ---------- Export to Excel (now 5 sheets) ----------
//   const handleExportToExcel = () => {
//     const wb = XLSX.utils.book_new();

//     const saleSheetData = saleRows.map((item) => ({
//       'Bill No': item.doc_no,
//       Date: formatDate(item.doc_date),
//       'Customer Name': item.billtoname,
//       'GST No': item.billtogstno,
//       'GST Rate': item.gstrate,
//       'Taxable Amount': Number(item.TaxableAmount) || 0,
//       'CGST Amt': Number(item.CGSTAmount) || 0,
//       'SGST Amt': Number(item.SGSTAmount) || 0,
//       'IGST Amt': Number(item.IGSTAmount) || 0,
//       'Bill Amount': Number(item.Bill_Amount) || 0,
//     }));
//     XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(saleSheetData), 'Sale Register');

//     // NEW: Halad Sale sheet
//     const haladSheetData = haladSaleRows.map((item) => ({
//       'Bill No': item.doc_no,
//       Date: formatDate(item.doc_date),
//       'Customer Name': item.CustomerName,
//       'Sub Total': Number(item.SubTotal) || 0,
//       'Bill Amount': Number(item.Bill_Amount) || 0,
//     }));
//     XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(haladSheetData), 'Halad Sale Register');

//     // NEW: Gul Sale sheet
//     const gulSheetData = gulSaleRows.map((item) => ({
//       'Bill No': item.doc_no,
//       Date: formatDate(item.doc_date),
//       'Customer Name': item.billtoname,
//       'GST No': item.billtogstno,
//       'GST Rate': item.gstrate,
//       'Taxable Amount': Number(item.TaxableAmount) || 0,
//       'CGST Amt': Number(item.CGSTAmount) || 0,
//       'SGST Amt': Number(item.SGSTAmount) || 0,
//       'IGST Amt': Number(item.IGSTAmount) || 0,
//       'Bill Amount': Number(item.Bill_Amount) || 0,
//     }));
//     XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(gulSheetData), 'Gul Sale Register');

//     const purchaseSheetData = purchaseRows.map((item) => ({
//       'Our No': item.doc_no,
//       Date: formatDate(item.doc_date),
//       'Bill No': item.Bill_No,
//       'Supplier Name': item.suppliername,
//       'Supplier GST No': item.suppliergstno,
//       'Taxable Amount': Number(item.subTotal) || 0,
//       'CGST Amt': Number(item.CGSTAmount) || 0,
//       'SGST Amt': Number(item.SGSTAmount) || 0,
//       'IGST Amt': Number(item.IGSTAmount) || 0,
//       'Bill Amount': Number(item.Bill_Amount) || 0,
//     }));
//     XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(purchaseSheetData), 'Purchase Register');

//     const summarySheetData = [
//       { Particulars: 'Included Sources', Value: activeSourceLabel },
//       { Particulars: 'Taxable Sale Amount', Value: summary.taxableSaleAmount },
//       { Particulars: 'Nil Rated Sale Amount', Value: summary.nilAmount },
//       { Particulars: 'Total Amount (Taxable + Nil)', Value: summary.totalSaleAmount },
//       { Particulars: 'Nil % (Nil / Total * 100)', Value: summary.nilPercent },
//       { Particulars: 'Taxable %', Value: summary.taxablePercent },
//       { Particulars: 'Purchase Total GST (CGST+SGST+IGST)', Value: summary.purchaseTotalGST },
//       { Particulars: 'ITC Reversal (attributable to Nil sales)', Value: summary.itcReversalNil },
//       { Particulars: 'Eligible ITC (Left-off Balance)', Value: summary.eligibleITC },
//       { Particulars: 'Total Sale GST (Sale + Gul, CGST+SGST+IGST)', Value: summary.totalSaleGST },
//       { Particulars: 'Payable Amount (Eligible ITC - Total Sale GST)', Value: summary.payableAmount },
//     ];
//     XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(summarySheetData), 'ITC Calculation');

//     XLSX.writeFile(wb, `GST_3B_ITC_Report_${fromDate}_to_${toDate}.xlsx`);
//   };

//   const handlePrint = () => {
//     window.print();
//   };

//   return (
//     <div style={{ marginTop: '-20px' }}>
//       <Typography variant="h6" style={{ textAlign: 'center', fontSize: '24px', fontWeight: 'bold', marginTop: '20px' }}>
//         {Company_Name}
//       </Typography>
//       <Typography variant="h6" style={{ textAlign: 'center', fontSize: '16px', textDecoration: 'underline', fontWeight: 550 }}>
//         GSTN : {Company_GSTNO}
//       </Typography>
//       <Typography variant="h6" style={{ textAlign: 'center', fontSize: '20px', fontWeight: 'bold' }}>
//         GST 3B - ITC Check Report
//       </Typography>
//       <Typography variant="h6" style={{ textAlign: 'center', fontSize: '16px' }}>
//         {FormaDateBalanceSheet(fromDate)} to {FormaDateBalanceSheet(toDate)}
//       </Typography>

//       {/* --- Filter bar --- */}
//       <div className="mb-3 row align-items-end justify-content-center g-2">
//         <div className="col-auto">
//           <label className="form-label mb-0">From Date</label>
//           <input
//             type="date"
//             className="form-control"
//             value={fromDate}
//             onChange={(e) => setFromDate(e.target.value)}
//           />
//         </div>
//         <div className="col-auto">
//           <label className="form-label mb-0">To Date</label>
//           <input
//             type="date"
//             className="form-control"
//             value={toDate}
//             onChange={(e) => setToDate(e.target.value)}
//           />
//         </div>
//         <div className="col-auto">
//           <button className="btn btn-primary" onClick={handleApplyDates}>
//             Apply
//           </button>
//         </div>
//         <div className="col-auto">
//           <button className="btn btn-secondary" onClick={handlePrint}>
//             Print
//           </button>
//         </div>
//         <div className="col-auto">
//           <button className="btn btn-success" onClick={handleExportToExcel}>
//             Export to Excel
//           </button>
//         </div>
//       </div>

//       {/* NEW: source toggles for the ITC Calculation Summary */}
//       <div className="mb-3 row justify-content-center g-3">
//         <div className="col-auto">
//           <span style={{ fontWeight: 600, marginRight: '8px' }}>Include in ITC calculation:</span>
//         </div>
//         <div className="col-auto form-check">
//           <input
//             type="checkbox"
//             className="form-check-input"
//             id="includeSaleChk"
//             checked={includeSale}
//             onChange={(e) => setIncludeSale(e.target.checked)}
//           />
//           <label className="form-check-label" htmlFor="includeSaleChk">Sale</label>
//         </div>
//         <div className="col-auto form-check">
//           <input
//             type="checkbox"
//             className="form-check-input"
//             id="includeHaladChk"
//             checked={includeHalad}
//             onChange={(e) => setIncludeHalad(e.target.checked)}
//           />
//           <label className="form-check-label" htmlFor="includeHaladChk">Halad</label>
//         </div>
//         <div className="col-auto form-check">
//           <input
//             type="checkbox"
//             className="form-check-input"
//             id="includeGulChk"
//             checked={includeGul}
//             onChange={(e) => setIncludeGul(e.target.checked)}
//           />
//           <label className="form-check-label" htmlFor="includeGulChk">Gul</label>
//         </div>
//       </div>

//       {error && <div className="alert alert-danger">{error}</div>}

//       {/* =========================== SALE REGISTER =========================== */}
//       <Paper elevation={2} style={{ marginBottom: '24px', padding: '8px' }}>
//         <Typography variant="subtitle1" style={{ fontWeight: 'bold', padding: '8px 12px', background: '#f5f5f5' }}>
//           1. Sale Register
//         </Typography>
//         <TableContainer style={{ maxHeight: '420px' }}>
//           <Table size="small" stickyHeader>
//             <TableHead>
//               <TableRow>
//                 <TableCell style={{ fontWeight: 'bold' }}>Bill No</TableCell>
//                 <TableCell style={{ fontWeight: 'bold' }}>Date</TableCell>
//                 <TableCell style={{ fontWeight: 'bold' }}>Customer Name</TableCell>
//                 <TableCell style={{ fontWeight: 'bold' }}>GST No</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>GST Rate</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>Taxable Amount</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>CGST Amt</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>SGST Amt</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>IGST Amt</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>Bill Amount</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {saleRows.map((item, idx) => (
//                 <TableRow key={idx} hover>
//                   <TableCell>{item.doc_no}</TableCell>
//                   <TableCell>{formatDate(item.doc_date)}</TableCell>
//                   <TableCell>{item.billtoname}</TableCell>
//                   <TableCell>{item.billtogstno}</TableCell>
//                   <TableCell style={{ textAlign: 'right' }}>{item.gstrate}</TableCell>
//                   <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.TaxableAmount)}</TableCell>
//                   <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.CGSTAmount)}</TableCell>
//                   <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.SGSTAmount)}</TableCell>
//                   <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.IGSTAmount)}</TableCell>
//                   <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.Bill_Amount)}</TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//             <TableFooter>
//               <TableRow style={{ backgroundColor: '#fff3cd' }}>
//                 <TableCell colSpan={5} style={{ fontWeight: 'bold' }}>Total</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(saleTotals.taxable)}</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(saleTotals.cgst)}</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(saleTotals.sgst)}</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(saleTotals.igst)}</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(saleTotals.billAmount)}</TableCell>
//               </TableRow>
//             </TableFooter>
//           </Table>
//         </TableContainer>
//       </Paper>

//       {/* =========================== HALAD SALE REGISTER (NEW) =========================== */}
//       <Paper elevation={2} style={{ marginBottom: '24px', padding: '8px' }}>
//         <Typography variant="subtitle1" style={{ fontWeight: 'bold', padding: '8px 12px', background: '#f5f5f5' }}>
//           2. Halad Sale Register (Nil Rated)
//         </Typography>
//         <TableContainer style={{ maxHeight: '420px' }}>
//           <Table size="small" stickyHeader>
//             <TableHead>
//               <TableRow>
//                 <TableCell style={{ fontWeight: 'bold' }}>Bill No</TableCell>
//                 <TableCell style={{ fontWeight: 'bold' }}>Date</TableCell>
//                 <TableCell style={{ fontWeight: 'bold' }}>Customer Name</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>Sub Total</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>Bill Amount</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {haladSaleRows.map((item, idx) => (
//                 <TableRow key={idx} hover>
//                   <TableCell>{item.doc_no}</TableCell>
//                   <TableCell>{formatDate(item.doc_date)}</TableCell>
//                   <TableCell>{item.CustomerName}</TableCell>
//                   <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.SubTotal)}</TableCell>
//                   <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.Bill_Amount)}</TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//             <TableFooter>
//               <TableRow style={{ backgroundColor: '#fff3cd' }}>
//                 <TableCell colSpan={3} style={{ fontWeight: 'bold' }}>Total</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(haladSaleTotals.subTotal)}</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(haladSaleTotals.billAmount)}</TableCell>
//               </TableRow>
//             </TableFooter>
//           </Table>
//         </TableContainer>
//       </Paper>

//       {/* =========================== GUL SALE REGISTER (NEW) =========================== */}
//       <Paper elevation={2} style={{ marginBottom: '24px', padding: '8px' }}>
//         <Typography variant="subtitle1" style={{ fontWeight: 'bold', padding: '8px 12px', background: '#f5f5f5' }}>
//           3. Gul Sale Register
//         </Typography>
//         <TableContainer style={{ maxHeight: '420px' }}>
//           <Table size="small" stickyHeader>
//             <TableHead>
//               <TableRow>
//                 <TableCell style={{ fontWeight: 'bold' }}>Bill No</TableCell>
//                 <TableCell style={{ fontWeight: 'bold' }}>Date</TableCell>
//                 <TableCell style={{ fontWeight: 'bold' }}>Customer Name</TableCell>
//                 <TableCell style={{ fontWeight: 'bold' }}>GST No</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>GST Rate</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>Taxable Amount</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>CGST Amt</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>SGST Amt</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>IGST Amt</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>Bill Amount</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {gulSaleRows.map((item, idx) => (
//                 <TableRow key={idx} hover>
//                   <TableCell>{item.doc_no}</TableCell>
//                   <TableCell>{formatDate(item.doc_date)}</TableCell>
//                   <TableCell>{item.billtoname}</TableCell>
//                   <TableCell>{item.billtogstno}</TableCell>
//                   <TableCell style={{ textAlign: 'right' }}>{item.gstrate}</TableCell>
//                   <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.TaxableAmount)}</TableCell>
//                   <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.CGSTAmount)}</TableCell>
//                   <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.SGSTAmount)}</TableCell>
//                   <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.IGSTAmount)}</TableCell>
//                   <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.Bill_Amount)}</TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//             <TableFooter>
//               <TableRow style={{ backgroundColor: '#fff3cd' }}>
//                 <TableCell colSpan={5} style={{ fontWeight: 'bold' }}>Total</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(gulSaleTotals.taxable)}</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(gulSaleTotals.cgst)}</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(gulSaleTotals.sgst)}</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(gulSaleTotals.igst)}</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(gulSaleTotals.billAmount)}</TableCell>
//               </TableRow>
//             </TableFooter>
//           </Table>
//         </TableContainer>
//       </Paper>

//       {/* ========================= PURCHASE REGISTER ========================= */}
//       <Paper elevation={2} style={{ marginBottom: '24px', padding: '8px' }}>
//         <Typography variant="subtitle1" style={{ fontWeight: 'bold', padding: '8px 12px', background: '#f5f5f5' }}>
//           4. Purchase Register (ITC)
//         </Typography>
//         <TableContainer style={{ maxHeight: '420px' }}>
//           <Table size="small" stickyHeader>
//             <TableHead>
//               <TableRow>
//                 <TableCell style={{ fontWeight: 'bold' }}>Our No</TableCell>
//                 <TableCell style={{ fontWeight: 'bold' }}>Date</TableCell>
//                 <TableCell style={{ fontWeight: 'bold' }}>Bill No</TableCell>
//                 <TableCell style={{ fontWeight: 'bold' }}>Supplier Name</TableCell>
//                 <TableCell style={{ fontWeight: 'bold' }}>Supplier GST No</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>Taxable Amount</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>CGST Amt</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>SGST Amt</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>IGST Amt</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>Bill Amount</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {purchaseRows.map((item, idx) => (
//                 <TableRow key={idx} hover>
//                   <TableCell>{item.doc_no}</TableCell>
//                   <TableCell>{formatDate(item.doc_date)}</TableCell>
//                   <TableCell>{item.Bill_No}</TableCell>
//                   <TableCell>{item.suppliername}</TableCell>
//                   <TableCell>{item.suppliergstno}</TableCell>
//                   <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.subTotal)}</TableCell>
//                   <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.CGSTAmount)}</TableCell>
//                   <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.SGSTAmount)}</TableCell>
//                   <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.IGSTAmount)}</TableCell>
//                   <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.Bill_Amount)}</TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//             <TableFooter>
//               <TableRow style={{ backgroundColor: '#fff3cd' }}>
//                 <TableCell colSpan={5} style={{ fontWeight: 'bold' }}>Total</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(purchaseTotals.taxable)}</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(purchaseTotals.cgst)}</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(purchaseTotals.sgst)}</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(purchaseTotals.igst)}</TableCell>
//                 <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(purchaseTotals.billAmount)}</TableCell>
//               </TableRow>
//             </TableFooter>
//           </Table>
//         </TableContainer>
//       </Paper>

//       {/* ====================== ITC REVERSAL / CALCULATION ==================== */}
//       <Paper elevation={3} style={{ marginBottom: '40px', padding: '16px', border: '1px solid #ddd' }}>
//         <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '4px' }}>
//           5. GST Reversal / ITC Calculation Summary
//         </Typography>
//         <Typography variant="body2" style={{ color: '#666', marginBottom: '12px' }}>
//           Based on: {activeSourceLabel}
//         </Typography>

//         <Grid container spacing={2}>
//           <Grid item xs={12} md={6}>
//             <SummaryRow label="Taxable Sale Amount" value={summary.taxableSaleAmount} />
//             <SummaryRow label="Nil Rated Sale Amount" value={summary.nilAmount} />
//             <SummaryRow label="Total Amount (Taxable + Nil)" value={summary.totalSaleAmount} />
//             <SummaryRow label="Nil % (Nil ÷ Total × 100)" value={summary.nilPercent} suffix="%" />
//             <SummaryRow label="Taxable %" value={summary.taxablePercent} suffix="%" />
//           </Grid>
//           <Grid item xs={12} md={6}>
//             <SummaryRow label="Total Sale GST (selected sources)" value={summary.totalSaleGST} negative />
//             <SummaryRow label="Purchase Total GST (CGST+SGST+IGST)" value={summary.purchaseTotalGST} />
//             <SummaryRow label="Eligible ITC (Left-off Balance)" value={summary.eligibleITC} />
//             <SummaryRow label="ITC Reversal (attributable to Nil sales)" value={summary.itcReversalNil} negative />
//           </Grid>
//         </Grid>

//         <Box mt={2} p={2} style={{ background: '#fff9c4', border: '1px solid #e6d200', borderRadius: '4px' }}>
//           <Typography style={{ fontWeight: 'bold', fontSize: '18px', textAlign: 'right' }}>
//             Payable / (Refund) Amount: ₹ {formatReadableAmount(summary.payableAmount)}
//           </Typography>
//         </Box>
//       </Paper>

//       {loading && (
//         <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 9999 }}>
//           <RingLoader size={80} />
//         </div>
//       )}
//     </div>
//   );
// };

// const SummaryRow = ({ label, value, suffix = '', negative = false }) => (
//   <div
//     style={{
//       display: 'flex',
//       justifyContent: 'space-between',
//       padding: '6px 4px',
//       borderBottom: '1px solid #eee',
//     }}
//   >
//     <span>{label}</span>
//     <span style={{ fontWeight: 600, color: negative ? '#c62828' : '#222' }}>
//       {suffix === '%' ? Number(value).toFixed(2) : formatReadableAmount(value)}
//       {suffix}
//     </span>
//   </div>
// );

// export default GST3BITCReport;




import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { useLocation } from 'react-router-dom';
import { formatReadableAmount } from '../../../Common/FormatFunctions/FormatAmount';
import { RingLoader } from 'react-spinners';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Typography, TableFooter, Box, Grid
} from '@mui/material';
import { FormaDateBalanceSheet } from '../../../Common/FormatFunctions/FormatDate';

const apikey = process.env.REACT_APP_API;


const HALAD_TRAN_TYPE = 'GS' || 'OS'; 

const GST3BITCReport = () => {
  const location = useLocation();
  const Company_Name = sessionStorage.getItem('Company_Name');
  const Company_GSTNO = sessionStorage.getItem('Company_GSTNO');
  const searchParams = new URLSearchParams(location.search);

  const [fromDate, setFromDate] = useState(searchParams.get('fromDate') || '');
  const [toDate, setToDate] = useState(searchParams.get('toDate') || '');

  const company_Code = sessionStorage.getItem("Company_Code");
  const YearCode = sessionStorage.getItem("Year_Code");

  const [saleData, setSaleData] = useState([]);
  const [purchaseData, setPurchaseData] = useState([]);
  const [haladSaleData, setHaladSaleData] = useState([]); // NEW
  const [gulSaleData, setGulSaleData] = useState([]);     // NEW
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // NEW: controls which sale sources feed the ITC Calculation Summary (section 5).
  // The register tables above always show full data regardless of these flags.
  const [includeSale, setIncludeSale] = useState(true);
  const [includeHalad, setIncludeHalad] = useState(true);
  const [includeGul, setIncludeGul] = useState(true);

  const SALE_API_URL = `${apikey}/generating_saleBill_report_Govermentreversing`;
  const PURCHASE_API_URL = `${apikey}/generating_purchaseReport_report_govermentreversing`;
  const HALAD_SALE_API_URL = `${apikey}/generating_haladsaleBill_report_Govermentreversing`; // NEW
  const GUL_SALE_API_URL = `${apikey}/generating_gulsaleBill_report_Govermentreversing`;       // NEW

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear());
    return `${day}/${month}/${year}`;
  };

  const dateRangeLabel =
    fromDate && toDate ? `${FormaDateBalanceSheet(fromDate)} to ${FormaDateBalanceSheet(toDate)}` : '';


  const fileDateFragment = fromDate && toDate ? `${fromDate}_to_${toDate}` : 'All';

  const fetchReportData = async () => {
    if (!company_Code || !YearCode) return;
    setLoading(true);
    setError('');
    try {
      const commonParams = {
        Company_Code: company_Code,
        Year_Code: YearCode,
        ...(fromDate && toDate ? { from_date: fromDate, to_date: toDate } : {}),
      };

      const [saleRes, purchaseRes, haladSaleRes, gulSaleRes] = await Promise.all([
        axios.get(SALE_API_URL, { params: commonParams }),
        axios.get(PURCHASE_API_URL, { params: commonParams }),
        axios.get(HALAD_SALE_API_URL, { params: { ...commonParams, Tran_Type: HALAD_TRAN_TYPE } }), // NEW
        axios.get(GUL_SALE_API_URL, { params: commonParams }), // NEW
      ]);

      setSaleData(saleRes.data?.all_data || []);
      setPurchaseData(purchaseRes.data?.all_data || []);
      setHaladSaleData(haladSaleRes.data?.all_data || []); // NEW
      setGulSaleData(gulSaleRes.data?.all_data || []);       // NEW
    } catch (err) {
      console.error('Error fetching report:', err);
      setError('Error fetching report');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReportData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company_Code, YearCode]);

  const handleApplyDates = () => {
    fetchReportData();
  };

  // ---------- SALE REGISTER (grouped by saleid, one row per bill) ----------
  const saleRows = useMemo(() => {
    const grouped = {};
    saleData.forEach((item) => {
      const key = item.saleid;
      if (!grouped[key]) grouped[key] = item;
    });
    return Object.values(grouped);
  }, [saleData]);

  const saleTotals = useMemo(() => {
    return saleRows.reduce(
      (acc, item) => {
        const taxableAmt = Number(item.TaxableAmount) || 0;
        const billAmt = Number(item.Bill_Amount) || 0;
        const isNil = (Number(item.gstrate) || 0) === 0;
        acc.billAmount += billAmt;
        acc.cgst += Number(item.CGSTAmount) || 0;
        acc.sgst += Number(item.SGSTAmount) || 0;
        acc.igst += Number(item.IGSTAmount) || 0;
        acc.netqntl += Number(item.NETQNTL) || 0;
        if (isNil) {
          acc.nilAmount += billAmt;
        } else {
          acc.taxable += taxableAmt;
        }
        return acc;
      },
      { taxable: 0, billAmount: 0, cgst: 0, sgst: 0, igst: 0, netqntl: 0, nilAmount: 0 }
    );
  }, [saleRows]);

  // ---------- HALAD SALE REGISTER (grouped by doc_no, one row per bill) ---------- NEW
  const haladSaleRows = useMemo(() => {
    const grouped = {};
    haladSaleData.forEach((item) => {
      const key = item.doc_no;
      if (!grouped[key]) grouped[key] = item;
    });
    return Object.values(grouped);
  }, [haladSaleData]);

  const haladSaleTotals = useMemo(() => {
    // Halad (mandi/turmeric) sale bills carry no CGST/SGST/IGST/gstrate fields from the API,
    // so the full bill amount is treated as nil-rated for the ITC nil% calculation.
    return haladSaleRows.reduce(
      (acc, item) => {
        const billAmt = Number(item.Bill_Amount) || 0;
        acc.subTotal += Number(item.SubTotal) || 0;
        acc.billAmount += billAmt;
        acc.nilAmount += billAmt;
        return acc;
      },
      { subTotal: 0, billAmount: 0, nilAmount: 0 }
    );
  }, [haladSaleRows]);

  // ---------- GUL SALE REGISTER (grouped by saleid, one row per bill) ---------- NEW
  const gulSaleRows = useMemo(() => {
    const grouped = {};
    gulSaleData.forEach((item) => {
      const key = item.saleid;
      if (!grouped[key]) grouped[key] = item;
    });
    return Object.values(grouped);
  }, [gulSaleData]);

  const gulSaleTotals = useMemo(() => {
    return gulSaleRows.reduce(
      (acc, item) => {
        const taxableAmt = Number(item.TaxableAmount) || 0;
        const billAmt = Number(item.Bill_Amount) || 0;
        const isNil = (Number(item.gstrate) || 0) === 0;
        acc.billAmount += billAmt;
        acc.cgst += Number(item.CGSTAmount) || 0;
        acc.sgst += Number(item.SGSTAmount) || 0;
        acc.igst += Number(item.IGSTAmount) || 0;
        if (isNil) {
          acc.nilAmount += billAmt;
        } else {
          acc.taxable += taxableAmt;
        }
        return acc;
      },
      { taxable: 0, billAmount: 0, cgst: 0, sgst: 0, igst: 0, nilAmount: 0 }
    );
  }, [gulSaleRows]);

  // ---------- PURCHASE REGISTER (grouped by purchaseid, one row per bill) ----------
  const purchaseRows = useMemo(() => {
    const grouped = {};
    purchaseData.forEach((item) => {
      const key = item.purchaseid;
      if (!grouped[key]) grouped[key] = item;
    });
    return Object.values(grouped);
  }, [purchaseData]);

  const purchaseTotals = useMemo(() => {
    return purchaseRows.reduce(
      (acc, item) => {
        acc.taxable += Number(item.subTotal) || 0;
        acc.billAmount += Number(item.Bill_Amount) || 0;
        acc.cgst += Number(item.CGSTAmount) || 0;
        acc.sgst += Number(item.SGSTAmount) || 0;
        acc.igst += Number(item.IGSTAmount) || 0;
        acc.netqntl += Number(item.NETQNTL) || 0;
        return acc;
      },
      { taxable: 0, billAmount: 0, cgst: 0, sgst: 0, igst: 0, netqntl: 0 }
    );
  }, [purchaseRows]);

  // ---------- FINAL CALCULATION / ITC REVERSAL SUMMARY ----------
  // Which sources feed in is now controlled by includeSale / includeHalad / includeGul,
  // so you can view Sale-only, Halad-only, Gul-only, or any combination.
  // Halad never contributes taxable/GST amounts (it has none), only nil amount, when included.
  const activeSourceLabel = useMemo(() => {
    const parts = [];
    if (includeSale) parts.push('Sale');
    if (includeHalad) parts.push('Halad');
    if (includeGul) parts.push('Gul');
    return parts.length ? parts.join(' + ') : 'None selected';
  }, [includeSale, includeHalad, includeGul]);

  const summary = useMemo(() => {
    const combinedTaxable =
      (includeSale ? saleTotals.taxable : 0) + (includeGul ? gulSaleTotals.taxable : 0);

    const combinedNil =
      (includeSale ? saleTotals.nilAmount : 0) +
      (includeHalad ? haladSaleTotals.nilAmount : 0) +
      (includeGul ? gulSaleTotals.nilAmount : 0);

    const totalSaleAmount = combinedTaxable + combinedNil;

    const nilPercent = totalSaleAmount ? (combinedNil / totalSaleAmount) * 100 : 0;
    const taxablePercent = totalSaleAmount ? 100 - nilPercent : 0;

    const purchaseTotalGST = purchaseTotals.cgst + purchaseTotals.sgst + purchaseTotals.igst;
    const itcReversalNil = purchaseTotalGST * (nilPercent / 100);
    const eligibleITC = purchaseTotalGST - itcReversalNil;

    // Total Sale GST across the currently selected sale sources (halad contributes 0 GST)
    const totalSaleGST =
      (includeSale ? saleTotals.cgst + saleTotals.sgst + saleTotals.igst : 0) +
      (includeGul ? gulSaleTotals.cgst + gulSaleTotals.sgst + gulSaleTotals.igst : 0);

    const payableAmount = eligibleITC - totalSaleGST;

    return {
      totalSaleAmount,
      nilAmount: combinedNil,
      taxableSaleAmount: combinedTaxable,
      nilPercent,
      taxablePercent,
      purchaseTotalGST,
      itcReversalNil,
      eligibleITC,
      totalSaleGST,
      payableAmount,
    };
  }, [saleTotals, haladSaleTotals, gulSaleTotals, purchaseTotals, includeSale, includeHalad, includeGul]);

  // ---------- Export to Excel (now 5 sheets) ----------
  const handleExportToExcel = () => {
    const wb = XLSX.utils.book_new();

    const saleSheetData = saleRows.map((item) => ({
      'Bill No': item.doc_no,
      Date: formatDate(item.doc_date),
      'Customer Name': item.billtoname,
      'GST No': item.billtogstno,
      'GST Rate': item.gstrate,
      'Taxable Amount': Number(item.TaxableAmount) || 0,
      'CGST Amt': Number(item.CGSTAmount) || 0,
      'SGST Amt': Number(item.SGSTAmount) || 0,
      'IGST Amt': Number(item.IGSTAmount) || 0,
      'Bill Amount': Number(item.Bill_Amount) || 0,
    }));
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(saleSheetData), 'Sale Register');

    // NEW: Halad Sale sheet
    const haladSheetData = haladSaleRows.map((item) => ({
      'Bill No': item.doc_no,
      Date: formatDate(item.doc_date),
      'Customer Name': item.CustomerName,
      'Sub Total': Number(item.SubTotal) || 0,
      'Bill Amount': Number(item.Bill_Amount) || 0,
    }));
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(haladSheetData), 'Halad Sale Register');

    // NEW: Gul Sale sheet
    const gulSheetData = gulSaleRows.map((item) => ({
      'Bill No': item.doc_no,
      Date: formatDate(item.doc_date),
      'Customer Name': item.billtoname,
      'GST No': item.billtogstno,
      'GST Rate': item.gstrate,
      'Taxable Amount': Number(item.TaxableAmount) || 0,
      'CGST Amt': Number(item.CGSTAmount) || 0,
      'SGST Amt': Number(item.SGSTAmount) || 0,
      'IGST Amt': Number(item.IGSTAmount) || 0,
      'Bill Amount': Number(item.Bill_Amount) || 0,
    }));
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(gulSheetData), 'Gul Sale Register');

    const purchaseSheetData = purchaseRows.map((item) => ({
      'Our No': item.doc_no,
      Date: formatDate(item.doc_date),
      'Bill No': item.Bill_No,
      'Supplier Name': item.suppliername,
      'Supplier GST No': item.suppliergstno,
      'Taxable Amount': Number(item.subTotal) || 0,
      'CGST Amt': Number(item.CGSTAmount) || 0,
      'SGST Amt': Number(item.SGSTAmount) || 0,
      'IGST Amt': Number(item.IGSTAmount) || 0,
      'Bill Amount': Number(item.Bill_Amount) || 0,
    }));
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(purchaseSheetData), 'Purchase Register');

    const summarySheetData = [
      { Particulars: 'Included Sources', Value: activeSourceLabel },
      { Particulars: 'Taxable Sale Amount', Value: summary.taxableSaleAmount },
      { Particulars: 'Nil Rated Sale Amount', Value: summary.nilAmount },
      { Particulars: 'Total Amount (Taxable + Nil)', Value: summary.totalSaleAmount },
      { Particulars: 'Nil % (Nil / Total * 100)', Value: summary.nilPercent },
      { Particulars: 'Taxable %', Value: summary.taxablePercent },
      { Particulars: 'Purchase Total GST (CGST+SGST+IGST)', Value: summary.purchaseTotalGST },
      { Particulars: 'ITC Reversal (attributable to Nil sales)', Value: summary.itcReversalNil },
      { Particulars: 'Eligible ITC (Left-off Balance)', Value: summary.eligibleITC },
      { Particulars: 'Total Sale GST (Sale + Gul, CGST+SGST+IGST)', Value: summary.totalSaleGST },
      { Particulars: 'Payable Amount (Eligible ITC - Total Sale GST)', Value: summary.payableAmount },
    ];
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(summarySheetData), 'ITC Calculation');

    XLSX.writeFile(wb, `GST_3B_ITC_Report_${fromDate}_to_${toDate}.xlsx`);
  };

  // ---------- Generate a real PDF from the actual data (no window.print / browser dialog) ----------
  const handleDownloadPDF = () => {
    const doc = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });
    const pageWidth = doc.internal.pageSize.getWidth();
    const marginX = 40;
    let y = 40;
 
    const fmt = (v) => formatReadableAmount(v);
 
    // ---- Header ----
    doc.setFontSize(16);
    doc.setFont(undefined, 'bold');
    doc.text(Company_Name || '', pageWidth / 2, y, { align: 'center' });
    y += 18;
 
    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
    doc.text(`GSTN : ${Company_GSTNO || ''}`, pageWidth / 2, y, { align: 'center' });
    y += 16;
 
    doc.setFontSize(13);
    doc.setFont(undefined, 'bold');
    doc.text('GST 3B - ITC Check Report', pageWidth / 2, y, { align: 'center' });
    y += 16;
 
    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
    doc.text(dateRangeLabel, pageWidth / 2, y, { align: 'center' });
    y += 12;
 
    doc.setFontSize(9);
    doc.text(`Included in ITC calculation: ${activeSourceLabel}`, pageWidth / 2, y, { align: 'center' });
    y += 20;
 
    const tableCommonOpts = {
      margin: { left: marginX, right: marginX },
      styles: { fontSize: 7.5, cellPadding: 3 },
      headStyles: { fillColor: [245, 245, 245], textColor: 20, fontStyle: 'bold' },
      footStyles: { fillColor: [255, 243, 205], textColor: 20, fontStyle: 'bold' },
    };
 
    // ---- 1. Sale Register ----
    doc.setFontSize(11);
    doc.setFont(undefined, 'bold');
    doc.text('1. Sale Register', marginX, y);
    y += 6;
    doc.autoTable({
      ...tableCommonOpts,
      startY: y,
      head: [['Bill No', 'Date', 'Customer Name', 'GST No', 'GST Rate', 'Taxable Amt', 'CGST', 'SGST', 'IGST', 'Bill Amt']],
      body: saleRows.map((item) => [
        item.doc_no, formatDate(item.doc_date), item.billtoname, item.billtogstno, item.gstrate,
        fmt(item.TaxableAmount), fmt(item.CGSTAmount), fmt(item.SGSTAmount), fmt(item.IGSTAmount), fmt(item.Bill_Amount),
      ]),
      foot: [['Total', '', '', '', '', fmt(saleTotals.taxable), fmt(saleTotals.cgst), fmt(saleTotals.sgst), fmt(saleTotals.igst), fmt(saleTotals.billAmount)]],
    });
    y = doc.lastAutoTable.finalY + 20;
 
    // ---- 2. Halad Sale Register ----
    doc.setFontSize(11);
    doc.setFont(undefined, 'bold');
    doc.text('2. Halad Sale Register (Nil Rated)', marginX, y);
    y += 6;
    doc.autoTable({
      ...tableCommonOpts,
      startY: y,
      head: [['Bill No', 'Date', 'Customer Name', 'Sub Total', 'Bill Amt']],
      body: haladSaleRows.map((item) => [
        item.doc_no, formatDate(item.doc_date), item.CustomerName, fmt(item.SubTotal), fmt(item.Bill_Amount),
      ]),
      foot: [['Total', '', '', fmt(haladSaleTotals.subTotal), fmt(haladSaleTotals.billAmount)]],
    });
    y = doc.lastAutoTable.finalY + 20;
 
    // ---- 3. Gul Sale Register ----
    doc.setFontSize(11);
    doc.setFont(undefined, 'bold');
    doc.text('3. Gul Sale Register', marginX, y);
    y += 6;
    doc.autoTable({
      ...tableCommonOpts,
      startY: y,
      head: [['Bill No', 'Date', 'Customer Name', 'GST No', 'GST Rate', 'Taxable Amt', 'CGST', 'SGST', 'IGST', 'Bill Amt']],
      body: gulSaleRows.map((item) => [
        item.doc_no, formatDate(item.doc_date), item.billtoname, item.billtogstno, item.gstrate,
        fmt(item.TaxableAmount), fmt(item.CGSTAmount), fmt(item.SGSTAmount), fmt(item.IGSTAmount), fmt(item.Bill_Amount),
      ]),
      foot: [['Total', '', '', '', '', fmt(gulSaleTotals.taxable), fmt(gulSaleTotals.cgst), fmt(gulSaleTotals.sgst), fmt(gulSaleTotals.igst), fmt(gulSaleTotals.billAmount)]],
    });
    y = doc.lastAutoTable.finalY + 20;
 
    // ---- 4. Purchase Register ----
    doc.setFontSize(11);
    doc.setFont(undefined, 'bold');
    doc.text('4. Purchase Register (ITC)', marginX, y);
    y += 6;
    doc.autoTable({
      ...tableCommonOpts,
      startY: y,
      head: [['Our No', 'Date', 'Bill No', 'Supplier Name', 'Supplier GST No', 'Taxable Amt', 'CGST', 'SGST', 'IGST', 'Bill Amt']],
      body: purchaseRows.map((item) => [
        item.doc_no, formatDate(item.doc_date), item.Bill_No, item.suppliername, item.suppliergstno,
        fmt(item.subTotal), fmt(item.CGSTAmount), fmt(item.SGSTAmount), fmt(item.IGSTAmount), fmt(item.Bill_Amount),
      ]),
      foot: [['Total', '', '', '', '', fmt(purchaseTotals.taxable), fmt(purchaseTotals.cgst), fmt(purchaseTotals.sgst), fmt(purchaseTotals.igst), fmt(purchaseTotals.billAmount)]],
    });
    y = doc.lastAutoTable.finalY + 20;
 
    // ---- 5. ITC Calculation Summary ----
    doc.setFontSize(11);
    doc.setFont(undefined, 'bold');
    doc.text('5. GST Reversal / ITC Calculation Summary', marginX, y);
    y += 6;
    doc.autoTable({
      ...tableCommonOpts,
      startY: y,
      theme: 'grid', // grid lines around every cell, so each row is visibly separated
      styles: { ...tableCommonOpts.styles, lineWidth: 0.5, lineColor: [180, 180, 180] },
      head: [['Particulars', 'Value']],
      body: [
        ['Included Sources', activeSourceLabel],
        ['Taxable Sale Amount', fmt(summary.taxableSaleAmount)],
        ['Nil Rated Sale Amount', fmt(summary.nilAmount)],
        ['Total Amount (Taxable + Nil)', fmt(summary.totalSaleAmount)],
        ['Nil %', `${summary.nilPercent.toFixed(2)}%`],
        ['Taxable %', `${summary.taxablePercent.toFixed(2)}%`],
        ['Purchase Total GST (CGST+SGST+IGST)', fmt(summary.purchaseTotalGST)],
        ['ITC Reversal (attributable to Nil sales)', fmt(summary.itcReversalNil)],
        ['Eligible ITC (Left-off Balance)', fmt(summary.eligibleITC)],
        ['Total Sale GST (selected sources)', fmt(summary.totalSaleGST)],
      ],
      columnStyles: { 1: { halign: 'right' } },
    });
    y = doc.lastAutoTable.finalY + 24;
 
    doc.setFontSize(12);
    doc.setFont(undefined, 'bold');
    doc.text(`Payable / (Refund) Amount: Rs. ${fmt(summary.payableAmount)}`, pageWidth - marginX, y, { align: 'right' });
 
    doc.save(`GST_3B_ITC_Report_${fileDateFragment}.pdf`);
  };

  return (
    <div style={{ marginTop: '-20px' }}>
      {/* NEW: print-only stylesheet.
          - Hides filter bar, source toggles, and loader from the printed page.
          - Removes the maxHeight/scroll clipping on tables so every row prints, not just the visible window.
          - Avoids splitting a table row or a whole register section across a page break where possible. */}
      <style>{`
        @media print {
          .no-print { display: none !important; }
          .MuiTableContainer-root { max-height: none !important; overflow: visible !important; }
          .MuiPaper-root { box-shadow: none !important; border: 1px solid #ccc !important; }
          .print-section { page-break-inside: avoid; }
          table tr { page-break-inside: avoid; }
          thead { display: table-header-group; }
          @page { size: landscape; margin: 12mm; }
        }
      `}</style>

      <Typography variant="h6" style={{ textAlign: 'center', fontSize: '24px', fontWeight: 'bold', marginTop:'20px' }}>
        {Company_Name}
      </Typography>
      <Typography variant="h6" style={{ textAlign: 'center', fontSize: '16px', textDecoration: 'underline', fontWeight: 550 }}>
        GSTN : {Company_GSTNO}
      </Typography>
      <Typography variant="h6" style={{ textAlign: 'center', fontSize: '20px', fontWeight: 'bold' }}>
        GST 3B - ITC Check Report
      </Typography>
      <Typography variant="h6" style={{ textAlign: 'center', fontSize: '16px' }}>
        {dateRangeLabel}
      </Typography>

      {/* --- Filter bar --- */}
      <div className="no-print mb-3 row align-items-end justify-content-center g-2">
        <div className="col-auto">
          <label className="form-label mb-0">From Date</label>
          <input
            type="date"
            className="form-control"
            value={fromDate || ""}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>
        <div className="col-auto">
          <label className="form-label mb-0">To Date</label>
          <input
            type="date"
            className="form-control"
            value={toDate || ""}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>
        <div className="col-auto">
          <button className="btn btn-primary" onClick={handleApplyDates}>
            Apply
          </button>
        </div>
        <div className="col-auto">
          <button className="btn btn-secondary" onClick={handleDownloadPDF}>
            Download PDF
          </button>
        </div>
        <div className="col-auto">
          <button className="btn btn-success" onClick={handleExportToExcel}>
            Export to Excel
          </button>
        </div>
      </div>

      {/* NEW: source toggles for the ITC Calculation Summary */}
      <div className="no-print mb-3 row justify-content-center g-3">
        <div className="col-auto">
          <span style={{ fontWeight: 600, marginRight: '8px' }}>Include in ITC calculation:</span>
        </div>
        <div className="col-auto form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id="includeSaleChk"
            checked={includeSale}
            onChange={(e) => setIncludeSale(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="includeSaleChk">Sale</label>
        </div>
        <div className="col-auto form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id="includeHaladChk"
            checked={includeHalad}
            onChange={(e) => setIncludeHalad(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="includeHaladChk">Halad</label>
        </div>
        <div className="col-auto form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id="includeGulChk"
            checked={includeGul}
            onChange={(e) => setIncludeGul(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="includeGulChk">Gul</label>
        </div>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      {/* =========================== SALE REGISTER =========================== */}
      <Paper className="print-section" elevation={2} style={{ marginBottom: '24px', padding: '8px' }}>
        <Typography variant="subtitle1" style={{ fontWeight: 'bold', padding: '8px 12px', background: '#f5f5f5' }}>
          1. Sale Register
        </Typography>
        <TableContainer style={{ maxHeight: '420px' }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: 'bold' }}>Bill No</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Date</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Customer Name</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>GST No</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>GST Rate</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>Taxable Amount</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>CGST Amt</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>SGST Amt</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>IGST Amt</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>Bill Amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {saleRows.map((item, idx) => (
                <TableRow key={idx} hover>
                  <TableCell>{item.doc_no}</TableCell>
                  <TableCell>{formatDate(item.doc_date)}</TableCell>
                  <TableCell>{item.billtoname}</TableCell>
                  <TableCell>{item.billtogstno}</TableCell>
                  <TableCell style={{ textAlign: 'right' }}>{item.gstrate}</TableCell>
                  <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.TaxableAmount)}</TableCell>
                  <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.CGSTAmount)}</TableCell>
                  <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.SGSTAmount)}</TableCell>
                  <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.IGSTAmount)}</TableCell>
                  <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.Bill_Amount)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow style={{ backgroundColor: '#fff3cd' }}>
                <TableCell colSpan={5} style={{ fontWeight: 'bold' }}>Total</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(saleTotals.taxable)}</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(saleTotals.cgst)}</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(saleTotals.sgst)}</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(saleTotals.igst)}</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(saleTotals.billAmount)}</TableCell>
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Paper>

      {/* =========================== HALAD SALE REGISTER (NEW) =========================== */}
      <Paper className="print-section" elevation={2} style={{ marginBottom: '24px', padding: '8px' }}>
        <Typography variant="subtitle1" style={{ fontWeight: 'bold', padding: '8px 12px', background: '#f5f5f5' }}>
          2. Halad Sale Register (Nil Rated)
        </Typography>
        <TableContainer style={{ maxHeight: '420px' }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: 'bold' }}>Bill No</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Date</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Customer Name</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>Sub Total</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>Bill Amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {haladSaleRows.map((item, idx) => (
                <TableRow key={idx} hover>
                  <TableCell>{item.doc_no}</TableCell>
                  <TableCell>{formatDate(item.doc_date)}</TableCell>
                  <TableCell>{item.CustomerName}</TableCell>
                  <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.SubTotal)}</TableCell>
                  <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.Bill_Amount)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow style={{ backgroundColor: '#fff3cd' }}>
                <TableCell colSpan={3} style={{ fontWeight: 'bold' }}>Total</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(haladSaleTotals.subTotal)}</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(haladSaleTotals.billAmount)}</TableCell>
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Paper>

      {/* =========================== GUL SALE REGISTER (NEW) =========================== */}
      <Paper className="print-section" elevation={2} style={{ marginBottom: '24px', padding: '8px' }}>
        <Typography variant="subtitle1" style={{ fontWeight: 'bold', padding: '8px 12px', background: '#f5f5f5' }}>
          3. Gul Sale Register
        </Typography>
        <TableContainer style={{ maxHeight: '420px' }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: 'bold' }}>Bill No</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Date</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Customer Name</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>GST No</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>GST Rate</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>Taxable Amount</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>CGST Amt</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>SGST Amt</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>IGST Amt</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>Bill Amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {gulSaleRows.map((item, idx) => (
                <TableRow key={idx} hover>
                  <TableCell>{item.doc_no}</TableCell>
                  <TableCell>{formatDate(item.doc_date)}</TableCell>
                  <TableCell>{item.billtoname}</TableCell>
                  <TableCell>{item.billtogstno}</TableCell>
                  <TableCell style={{ textAlign: 'right' }}>{item.gstrate}</TableCell>
                  <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.TaxableAmount)}</TableCell>
                  <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.CGSTAmount)}</TableCell>
                  <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.SGSTAmount)}</TableCell>
                  <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.IGSTAmount)}</TableCell>
                  <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.Bill_Amount)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow style={{ backgroundColor: '#fff3cd' }}>
                <TableCell colSpan={5} style={{ fontWeight: 'bold' }}>Total</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(gulSaleTotals.taxable)}</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(gulSaleTotals.cgst)}</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(gulSaleTotals.sgst)}</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(gulSaleTotals.igst)}</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(gulSaleTotals.billAmount)}</TableCell>
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Paper>

      {/* ========================= PURCHASE REGISTER ========================= */}
      <Paper className="print-section" elevation={2} style={{ marginBottom: '24px', padding: '8px' }}>
        <Typography variant="subtitle1" style={{ fontWeight: 'bold', padding: '8px 12px', background: '#f5f5f5' }}>
          4. Purchase Register (ITC)
        </Typography>
        <TableContainer style={{ maxHeight: '420px' }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: 'bold' }}>Our No</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Date</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Bill No</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Supplier Name</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Supplier GST No</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>Taxable Amount</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>CGST Amt</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>SGST Amt</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>IGST Amt</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>Bill Amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {purchaseRows.map((item, idx) => (
                <TableRow key={idx} hover>
                  <TableCell>{item.doc_no}</TableCell>
                  <TableCell>{formatDate(item.doc_date)}</TableCell>
                  <TableCell>{item.Bill_No}</TableCell>
                  <TableCell>{item.suppliername}</TableCell>
                  <TableCell>{item.suppliergstno}</TableCell>
                  <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.subTotal)}</TableCell>
                  <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.CGSTAmount)}</TableCell>
                  <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.SGSTAmount)}</TableCell>
                  <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.IGSTAmount)}</TableCell>
                  <TableCell style={{ textAlign: 'right' }}>{formatReadableAmount(item.Bill_Amount)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow style={{ backgroundColor: '#fff3cd' }}>
                <TableCell colSpan={5} style={{ fontWeight: 'bold' }}>Total</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(purchaseTotals.taxable)}</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(purchaseTotals.cgst)}</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(purchaseTotals.sgst)}</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(purchaseTotals.igst)}</TableCell>
                <TableCell style={{ fontWeight: 'bold', textAlign: 'right' }}>{formatReadableAmount(purchaseTotals.billAmount)}</TableCell>
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Paper>

      {/* ====================== ITC REVERSAL / CALCULATION ==================== */}
      <Paper className="print-section" elevation={3} style={{ marginBottom: '40px', padding: '16px', border: '1px solid #ddd' }}>
        <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '4px' }}>
          5. GST Reversal / ITC Calculation Summary
        </Typography>
        <Typography variant="body2" style={{ color: '#666', marginBottom: '12px' }}>
          Based on: {activeSourceLabel}
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <SummaryRow label="Taxable Sale Amount" value={summary.taxableSaleAmount} />
            <SummaryRow label="Nil Rated Sale Amount" value={summary.nilAmount} />
            <SummaryRow label="Total Amount (Taxable + Nil)" value={summary.totalSaleAmount} />
            <SummaryRow label="Nil % (Nil ÷ Total × 100)" value={summary.nilPercent} suffix="%" />
            <SummaryRow label="Taxable %" value={summary.taxablePercent} suffix="%" />
          </Grid>
          <Grid item xs={12} md={6}>
            <SummaryRow label="Total Sale GST (selected sources)" value={summary.totalSaleGST} negative />
            <SummaryRow label="Purchase Total GST (CGST+SGST+IGST)" value={summary.purchaseTotalGST} />
            <SummaryRow label="Eligible ITC (Left-off Balance)" value={summary.eligibleITC} />
            <SummaryRow label="ITC Reversal (attributable to Nil sales)" value={summary.itcReversalNil} negative />
          </Grid>
        </Grid>

        <Box mt={2} p={2} style={{ background: '#fff9c4', border: '1px solid #e6d200', borderRadius: '4px' }}>
          <Typography style={{ fontWeight: 'bold', fontSize: '18px', textAlign: 'right' }}>
            Payable / (Refund) Amount: ₹ {formatReadableAmount(summary.payableAmount)}
          </Typography>
        </Box>
      </Paper>

      {loading && (
        <div className="no-print" style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 9999 }}>
          <RingLoader size={80} />
        </div>
      )}
    </div>
  );
};

const SummaryRow = ({ label, value, suffix = '', negative = false }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      padding: '6px 4px',
      borderBottom: '1px solid #eee',
    }}
  >
    <span>{label}</span>
    <span style={{ fontWeight: 600, color: negative ? '#c62828' : '#222' }}>
      {suffix === '%' ? Number(value).toFixed(2) : formatReadableAmount(value)}
      {suffix}
    </span>
  </div>
);

export default GST3BITCReport;